import { createFeature, createReducer, on } from '@ngrx/store';
import { ToastMessageOptions } from 'primeng/api';
import { ToastActions } from './toast.actions';

export interface ToastState {
  messages: ToastMessageOptions[];
  visible: boolean;
}

export const initialState: ToastState = {
  messages: [],
  visible: false,
};

const createMessage = (
  severity: string,
  summary?: string,
  detail?: string,
  life: number = 3000
): ToastMessageOptions => ({
  severity,
  summary: summary || severity.charAt(0).toUpperCase() + severity.slice(1),
  detail: detail || `${severity.charAt(0).toUpperCase() + severity.slice(1)} message.`,
  life,
});

export const toastFeature = createFeature({
  name: 'toast',
  reducer: createReducer(
    initialState,
    on(ToastActions.showToast, (state, { message }) => ({
      ...state,
      messages: [message],
      visible: true,
    })),
    on(ToastActions.showSuccessToast, (state, { summary, detail }) => ({
      ...state,
      messages: [createMessage('success', summary, detail)],
      visible: true,
    })),
    on(ToastActions.showInfoToast, (state, { summary, detail }) => ({
      ...state,
      messages: [createMessage('info', summary, detail)],
      visible: true,
    })),
    on(ToastActions.showWarnToast, (state, { summary, detail }) => ({
      ...state,
      messages: [createMessage('warn', summary, detail, 4000)],
      visible: true,
    })),
    on(ToastActions.showErrorToast, (state, { summary, detail }) => ({
      ...state,
      messages: [createMessage('error', summary, detail, 5000)],
      visible: true,
    })),
    on(ToastActions.hideToast, (state) => ({
      ...state,
      messages: [],
      visible: false,
    }))
  ),
});

export const {
  name: toastFeatureKey,
  reducer: toastReducer,
  selectToastState,
  selectMessages,
  selectVisible,
} = toastFeature;
